import { useNavigate } from "react-router-dom";
import PlansPanel from "../components/PlansPanel";
import useSubscriptionAccess from "../hooks/useSubscriptionAccess";

const Subscribe = () => {
  const navigate = useNavigate();
  const { subscription, refresh } = useSubscriptionAccess();

  return (
    <div className="subscribe-page">
      <div className="page-head">
        <div>
          <h2>Plans &amp; pricing</h2>
          <p>
            {subscription
              ? `Current plan: ${subscription.plan_display_name} · expires ${new Date(subscription.expires_at).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" })}`
              : "Pick a plan to unlock broadcasting, templates, flows and the AI chatbot"}
          </p>
        </div>
        <div className="grow" />
        {subscription && <span className="ping-chip g">Active</span>}
      </div>

      <PlansPanel
        showAddons
        onSubscribed={async () => {
          await refresh();
          navigate("/dashboard");
        }}
      />
    </div>
  );
};

export default Subscribe;
